import type { SVGProps } from 'react';
const SvgCaravanSimpleSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" {...props}>
    <path d="M80 32C35.8 32 0 67.8 0 112v224c0 44.2 35.8 80 80 80h16c0 53 43 96 96 96s96-43 96-96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V192c0-88.4-71.6-160-160-160zM64 160c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm288-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32M144 416a48 48 0 1 1 96 0 48 48 0 1 1-96 0" />
  </svg>
);
export default SvgCaravanSimpleSolid;
